// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2hAFv","content":"ManualTimeModal_content__3HAgJ"};